/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle-alert': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm.008 9.833a.5.5 0 01.09.992l-.09.008a.5.5 0 01-.098-.992l.098-.008zM10 6.167a.5.5 0 01.492.41l.008.09V10a.5.5 0 01-.992.09L9.5 10V6.667a.5.5 0 01.5-.5z" _fill="#E5092B"/>'
  }
})
